import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Image from "react-bootstrap/Image";
import { Link } from "react-router-dom";
import { OverlayTrigger } from "react-bootstrap";
import Tooltip from "react-bootstrap/Tooltip";
function index(props) {
  var settings = {
    dots: window.innerWidth >= 992 ? false : true,
    infinite: true,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 6,
    vertical: window.innerWidth >= 992 ? true : false,
    centerMode: false,
    arrows: window.innerWidth >= 992 ? true : false,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 6,
        },
      },

      {
        breakpoint: 575,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
        },
      },
    ],
  };
  return (
    <Slider {...settings} className="my-auto">
      {/* {console.log(props)} */}
      {props.slides.map((pic, i) => (
        <div className={`ratio ratio-1x1 my-2`} key={i}>
          <OverlayTrigger
            overlay={
              <Tooltip style={{ position: "fixed" }}>{pic.tooltip}</Tooltip>
            }
          >
            <Link to={pic.link}>
              <Image src={pic.pic} fluid style={{ objectFit: "cover" }} />
            </Link>
          </OverlayTrigger>
        </div>
      ))}
    </Slider>
  );
}

export default index;
